/* global axios */
import ApiClient, { Utility } from './ApiClient';

export const buildCreatePayload = data => {
  let payload;
  const { file, ...message } = data.message || {};
  if (file) {
    data.message = message;
    payload = new FormData();
    payload.append('message[attachments][]', file);
    Utility.convertModelToFormData(data, payload, '', 'conversation');
  } else {
    payload = data;
  }
  return payload;
};

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, buildCreatePayload(data));
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getCurrentTicket(conversationID) {
    return axios.get(`${this.url}/${conversationID}/tickets/current`);
  }

  updateTicketCustomAttributes(conversationID, ticketID, customAttributes) {
    return axios.put(`${this.url}/${conversationID}/tickets/${ticketID}`, {
      custom_attributes: customAttributes,
    });
  }

  destroyTicketCustomAttributes(conversationID, ticketID, customAttributes) {
    return axios.put(
      `${this.url}/${conversationID}/tickets/${ticketID}/destroy_custom_attributes`,
      {
        custom_attributes: customAttributes,
      }
    );
  }
}

export default new ConversationApi();
